'use client'

import Link from 'next/link'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import { DotLottieReact } from '@lottiefiles/dotlottie-react'

import type { Mode } from '@core/types'

import { useImageVariant } from '@core/hooks/useImageVariant'

const NotFound = ({ mode }: { mode: Mode }) => {
  const darkImg = '/images/pages/misc-mask-1-dark.png'
  const lightImg = '/images/pages/misc-mask-1-light.png'

  const miscBackground = useImageVariant(mode, lightImg, darkImg)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        position: 'relative',
        padding: 3,
        overflow: 'hidden'
      }}
    >
      <Stack
        spacing={10}
        alignItems='center'
        sx={{
          textAlign: 'center',
          width: '100%'
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '100%',
            height: '70dvh'
          }}
        >
          <DotLottieReact
            src='https://lottie.host/5923c8a5-ee15-4b7b-b4cd-080cef4d82b3/hHVHzQCeow.lottie'
            loop
            autoplay
            style={{ width: '100%', height: '100%' }}
          />
        </Box>

        <Button href='/' component={Link} variant='contained'>
          Back to Home
        </Button>
      </Stack>

      <Box
        component='img'
        src={miscBackground}
        sx={{
          position: 'absolute',
          bottom: 0,
          zIndex: -1,
          width: '100%',
          display: { xs: 'none', md: 'block' }
        }}
      />
    </Box>
  )
}

export default NotFound
